const GoalsErrorState: React.FC<{ error: string | null }> = ({ error }) => {
    if (!error) return null;

    return (
        <div className="p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg">
            {error}
        </div>
    );
};

export default GoalsErrorState;